export default __webpack_public_path__ + "static/media/mobile_home.721676eb.mp4";